import React from 'react'
import { H3, Text } from '../../../../../../../../../Styles/typography'
import { InfoEl } from './elements'
import SubmissionsStore from '../../stores/SubmissionsStore'

const Info = () => {
  const { activeSubmission } = SubmissionsStore.useContainer()

  return !activeSubmission ? null : (
    <InfoEl>
      <Text>{activeSubmission?.chapter.title}</Text>
      <H3>{activeSubmission?.lesson.title}</H3>
      <div
        className='description'
        dangerouslySetInnerHTML={{
          __html: activeSubmission?.lesson.description,
        }}
      />
    </InfoEl>
  )
}

export default Info
